import api from "../../../api/axios";

// Companion Property summary transport for Deal screens.
// GET only — bounded per-screen usage with deduplication in the loader.

export const fetchPropertySummary = (propertyId, { signal } = {}) =>
  api
    .get(`/realty/properties/${propertyId}/`, { signal })
    .then((res) => res.data);
